module.exports = {
    extends: [
        '/',
        'base',
        'form',
        'media',
        'upload',
        'plupload',
        'plupload'
    ],

    config: {
        mode: 'instantUploader',
        autoOpenUploadDialog: true,
        isInstantUploader: true,
        showResultsContainer: true,
        // secureRoute: '/~/subscriberImporter',
        pluploaderConfig: {
            multi_selection: false,
            // url: '/LTR/~/subscriberImporter',
            // filters: {
            //     mime_types: [
            //         {
            //             title: 'Files',
            //             extensions: 'csv,xlsx'
            //         }
            //     ]
            // }
        }
    },
}